const template = require("templates/photos/modal-body.hbs");

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }


L2H.PhotoModalBodyView = class PhotoModalBodyView {
  constructor($container, options) {
    this.setPhoto = this.setPhoto.bind(this);
    this.$container = $container;
    if (options == null) { options = {}; }
    this.options = options;
    this.shopablesView = new L2H.ShopablesView([], this.$container, this.options);
    this.modalShowing = false;
    this.selectedPhoto = null;
    this.bindEvents();
  }

  render() {
    const context = {
      photo: this.selectedPhoto,
      assetHost: L2H.assetHost,
      url: this.selectedPhoto.shopables.length === 1 ? this.selectedPhoto.shopables[0].url : undefined,
      linkTarget: this.options.openShopableLinksInNewWindow ? "_blank" : "_self",
      shareURL: `${L2H.rootURL}p/${this.selectedPhoto.share_id}`,
      aspectAsPercentage: (this.selectedPhoto.height / this.selectedPhoto.width) * 100,
      features: L2H.features
    };

    const renderedModalBody = template(context);
    return this.$container.find('.l2h-photomodal-body').html(renderedModalBody);
  }

  //
  // event bindings - be careful to ensure that binding to document is
  // only done once as this function could be called more than once.
  //
  bindEvents() {
    const self = this;
    return this.$container
      .on('l2h-hide.modal', () => {
          // useful in case we need to target site specific css to be engaged
          // when the modal is hidden
        $('html').removeClass('l2h-showing-modal');
      })
      .on('l2h-show.modal', () =>
              // useful in case we need to target site specific css to be engaged
              // when the modal is displayed
              $('html').addClass('l2h-showing-modal')
             ).on('l2h-hidden.modal', function() {
               if (L2H.debug) {
                 console.log("L2H DEBUG: l2h-hidden.modal received");
               }

               self.modalShowing = false;
               self.setPhoto(null);
               return self.shopablesView.shopables = [];
             })
      .on('l2h-shown.modal', function() {
        if (L2H.debug) {
          console.log("L2H DEBUG: l2h-shown.modal received in photo-modal-body-view");
        }

        self.modalShowing = true;
        return self.shopablesView.render(self.selectedPhoto.shopables);
      })
      .on('click.dismiss.l2h.modal', '[data-dismiss="l2h-photomodal"]', function(e) {
        e.preventDefault();
        self.hide();
      });
  }

  //
  // public functions
  //
  show() {
    this.$container.trigger('l2h-show.modal');
    this.$container.find('.l2h-photomodal-container').addClass('l2h-modal-on');
    this.$container.trigger('l2h-shown.modal');
  }

  hide() {
    this.$container.trigger('l2h-hide.modal');
    this.$container.find('.l2h-photomodal-container').removeClass('l2h-modal-on');
    this.$container.trigger('l2h-hidden.modal');
  }

  isModalShowing() {
    return this.modalShowing;
  }

  setPhoto(photo) {
    this.selectedPhoto = photo;
    if (photo) {
      this.render();
      if (this.modalShowing) {
        this.shopablesView.render(photo.shopables);
      }
    }
  }
};
